function initPressSlider(root) {
  const viewport = root.querySelector('[data-press-viewport]');
  const slides = Array.from(root.querySelectorAll('[data-press-slide]'));
  const prevBtn = root.querySelector('[data-press-prev]');
  const nextBtn = root.querySelector('[data-press-next]');
  const dots = Array.from(root.querySelectorAll('[data-press-dot]'));

  if (!viewport || slides.length < 2) return;

  const autoplayEnabled = root.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
  const pauseOnHover = root.dataset.pauseOnHover === 'true';

  let autoplayTimer = null;
  let isPaused = false;

  function scrollByDirection(direction) {
    viewport.scrollBy({ left: viewport.clientWidth * direction, behavior: 'smooth' });
  }

  function goToSlide(index) {
    viewport.scrollTo({ left: viewport.clientWidth * index, behavior: 'smooth' });
  }

  function currentIndex() {
    return Math.round(viewport.scrollLeft / viewport.clientWidth);
  }

  function updateActiveDot() {
    const index = currentIndex();
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  function goToNextSlide() {
    const nextIndex = (currentIndex() + 1) % slides.length;
    goToSlide(nextIndex);
  }

  function startAutoplay() {
    if (!autoplayEnabled || isPaused) return;
    stopAutoplay();
    autoplayTimer = setInterval(goToNextSlide, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  // Restart the timer whenever the user manually navigates,
  // so autoplay doesn't jump right after a manual interaction.
  function restartAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  prevBtn && prevBtn.addEventListener('click', () => {
    scrollByDirection(-1);
    restartAutoplay();
  });

  nextBtn && nextBtn.addEventListener('click', () => {
    scrollByDirection(1);
    restartAutoplay();
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      goToSlide(parseInt(dot.dataset.index, 10));
      restartAutoplay();
    });
  });

  viewport.addEventListener('scroll', updateActiveDot, { passive: true });

  if (autoplayEnabled) {
    if (pauseOnHover) {
      root.addEventListener('mouseenter', () => {
        isPaused = true;
        stopAutoplay();
      });
      root.addEventListener('mouseleave', () => {
        isPaused = false;
        startAutoplay();
      });
    }

    // Pause on touch so mobile users can swipe without it jumping mid-gesture
    viewport.addEventListener('touchstart', () => {
      isPaused = true;
      stopAutoplay();
    }, { passive: true });
    viewport.addEventListener('touchend', () => {
      isPaused = false;
      startAutoplay();
    }, { passive: true });

    // Pause when the tab isn't visible, resume when it is
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else if (!isPaused) {
        startAutoplay();
      }
    });

    startAutoplay();
  }
}

document.querySelectorAll('[data-press-slider]').forEach(initPressSlider);

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-press-slider]');
  if (root) initPressSlider(root);
});